export default __webpack_public_path__ + "static/media/empty-creative.7210d777.svg";